import get from 'lodash/get';

export const ResponseHelpers = {
  isStatusOk(status) {
    return status >= 200 && status <= 299;
  },

  isClientError(status) {
    return status >= 400 && status <= 499;
  },

  isServerError(status) {
    return status >= 500 && status <= 599;
  },

  isAborted(response) {
    return response.status === 0 && !response.statusText;
  },
};

/**
 * Status codes returned by the API
 */
export const HttpResponseCodes = {
  BLOCKED_BY_CLIENT: 0,
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  EXPECTATION_FAILED: 417,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  LIMIT_REACHED: 480,
  USER_BLOCKED: 481,
  UNAVAILABLE_PARENT: 482,
};

/**
 * Process response data to only return what is needed by the application.
 *
 * @param  {Object} response Original response from axios
 * @return {Object}          Filtered plain object
 */
export function processResponse(response) {
  return {
    status: response.status,
    statusText: response.statusText,
    ok: true,
    aborted: ResponseHelpers.isAborted(response),
    body: response.data,
  };
}

/**
 * Extend original response error to include properties expected by the application
 *
 * @param  {Object} originalError Original response error from axios
 * @throws {Object}               Throws an error with the data expected by the aplication.
 */
export function processError(originalError) {
  originalError.body = get(originalError, 'response.data', {});
  originalError.status = get(originalError, 'response.status', 0);
  originalError.statusText = get(originalError, 'response.statusText', '');
  originalError.ok = false;

  throw originalError;
}
